import { render, staticRenderFns } from "./TabsDashboardPassId.vue?vue&type=template&id=b341c6d0&"
import script from "./TabsDashboardPassId.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardPassId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports